// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__1Nh-g","center":"Spinner_center__3BVUM"};